<template>
    <b-card-group class="card-group-landing">
        <b-card
            no-body>
            <news-content-card
                :news-card-title="newsCardProps.title"
                :news-card-bundle="newsCardProps.bundle"/>
        </b-card>
        <b-card
            no-body>
            <links-content-card
                :link-card-title="linkCardProps.startHere.title"
                :link-card-bundle="linkCardProps.startHere.bundle"/>
        </b-card>
        <b-card
            no-body>
            <links-content-card
                :link-card-title="linkCardProps.quickLinks.title"
                :link-card-bundle="linkCardProps.quickLinks.bundle"/>
        </b-card>
    </b-card-group>
</template>

<script>

import LandingContentBaseComponent from './LandingContentBaseComponent.vue';
export default {
    name: 'PrimaryLandingContent',
    extends: LandingContentBaseComponent,
    data() {
        return {
            newsCardProps: {
                title: 'News',
                bundle: 'NEWSLINKS'
            },
            linkCardProps: {
                startHere: {
                    title: 'Start Here',
                    bundle: 'STARTHERELINKS'
                },
                quickLinks: {
                    title: 'Quick Links',
                    bundle: 'QUICKLINKS'
                }
            }
        };
    },
    computed: { },
    methods: { }
};
</script>
